import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";

import layoutActions from "../../redux/actions/layout.actions";
import actions from "../../redux/actions/auth.actions";
import { GetScreenSize } from "../../utils/screenSize";
import { useNavigate } from "react-router-dom";
import { Box, Toolbar, Button, MenuItem, useTheme } from "@mui/material";
import NavBarRoot from "./NavBarRoot";
import StyledMenu from "./StyledMenu";
import { Menu, Person, Notifications } from "@mui/icons-material";

interface Props {
  sideNavState: boolean;
  sideNavChange: (value: boolean) => void;
  logout: () => void;
  // onSave,
  // onCancel,
  // isSubmitting,
  leftComponents?: any;
  // updateHeaderState,
  extraComponent?: any;
}

const Header: React.FC<Props> = ({
  sideNavState,
  sideNavChange,
  logout,
  // onSave,
  // onCancel,
  // isSubmitting,
  leftComponents,
  // updateHeaderState,
  extraComponent,
}) => {
  const theme = useTheme();

  // useEffect(() => {
  //   if (onSave && onCancel) {
  //     updateHeaderState(true)
  //   }
  // }, [onSave, onCancel])

  const screenSize = GetScreenSize();
  const [userMenu, setUserMenu] = useState(false);
  const open = Boolean(userMenu);
  const navigate = useNavigate();
  const handleClick = (event: any) => {
    setUserMenu(event.currentTarget);
  };

  const user = JSON.parse(localStorage.getItem("user") ?? "{}"); 
  const displayedName = user ? user.firstName : "user";
  const handleActions = (act: "account-settings" | "users" | "logout") => {
    setUserMenu(false);
    if (act)
      switch (act) {
        case "logout":
          logout();
          break;
        case "account-settings":
          navigate("/user-profile");
          break;
        // case 'users':
        //   navigate('/users')
        default:
          return "";
      }
  };

  return (
    <NavBarRoot>
      <Toolbar
        sx={{
          minHeight: 64,
          display: "flex",
          alignItems: "center",
          maxWidth: "100%",
        }}
      >
        <Box
          sx={{
            backgroundColor: theme.palette.primary.main,
            padding: 1,
            display: "flex",
            alignItems: "center",
            borderRadius: "8px",
            cursor: "pointer",
            transform: `${
              sideNavState && screenSize.dynamicWidth > 666
                ? `translateX(210px)`
                : "none"
            }`,
            transition:
              "transform 125ms cubic-bezier(0, 0, 0.2, 1) 0ms !Important",
            zIndex: 10,
          }}
          onClick={() => sideNavChange(!sideNavState)}
        >
          <Menu />
        </Box>
        <Box
          sx={{
            position: "absolute",
            right: 20,
            marginLeft: 12,
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            ...(sideNavState && { marginLeft: "220px" }),
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              marginLeft: sideNavState ? "300px" : 12,
            }}
          >
            {leftComponents && leftComponents}
            {extraComponent && extraComponent}
            {/* {onCancel && onSave &&
              <Box sx={{ display: 'flex' }}>
                <Button
                  variant='contained'
                  color='secondary'
                  sx={{ marginRight: 0.5 }}
                  onClick={onCancel}
                  size='small'
                >
                  {getField(
                    dictionary,
                    "cancel",
                    language
                  )} 
                </Button>
                <LoadingButton
                  disabled={isSubmitting}
                  isSubmitting={isSubmitting}
                  title={getField(
                    dictionary,
                    "save",
                    language
                  )}
                  variant='contained'
                  sx={{ marginLeft: 0.5, padding: '6px' }}
                  onClick={onSave}
                  size='small'
                /> 
              </Box>
            } */}
          </Box>
          <Button
            sx={{ marginLeft: 1, padding: "6px", minWidth: 40, width: "auto" }}
            variant="contained"
            size="small"
          >
            <Notifications />
          </Button>
          <Button
            aria-expanded={open ? "true" : undefined}
            variant="contained"
            disableElevation
            onClick={handleClick}
            sx={{
              marginLeft: 1,
              minWidth: screenSize.dynamicWidth > 667 ? 80 : 40,
              padding: "6px",
              width: "auto",
            }}
            // endIcon={screenSize.dynamicWidth > 667 ? getSVG('arrow-down', theme.palette.userMenu.icons, { width: 10, height: 10 }, userMenu) : null}
            size="small"
          >
            <Person />
            {screenSize.dynamicWidth > 667 ? displayedName : null}
          </Button>
          <StyledMenu
            anchorEl={userMenu}
            open={open}
            onClose={() => setUserMenu(false)}
          >
            {
              <MenuItem onClick={() => handleActions("account-settings")}>
                Account settings
              </MenuItem>
              /*
            <MenuItem onClick={() => handleActions('users')}>
              settings
            </MenuItem> */
            }
            <MenuItem onClick={() => handleActions("logout")}>
              {/* {getField(
                dictionary,
                "logout",
                language
              )} */}
              logout
            </MenuItem>
            {/* <MenuItem onClick={() => handleActions('choose-lang')}>
              {getField(
                dictionary,
                "language-settings",
                language
              )}

              lan
            </MenuItem> */}
          </StyledMenu>
        </Box>
      </Toolbar>
      {/* <ChooseLanguage
        isOpen={chooseLangModalState}
        onClose={closeChooseLanguage}
        dictionary={dictionary}
        getField={getField}
      /> */}
    </NavBarRoot>
  );
};

const mapStateToProps = (state: any) => ({
  sideNavState: state.layout.sideNavOpen,
});
const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  logout: () => dispatch(actions.logoutAction()),
  sideNavChange: (state: boolean) =>
    dispatch(layoutActions.updateSideNav(state)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
